import InlineDialog from './InlineDialog';

export default InlineDialog;
